<template>
    <b-card no-body>
        <v-table    ref="table"
                    :add-callback="createNew"
                    name = "reference-model"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search
                    :items-provider="provider"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CalculatePriceApi from '@/api/calculate-price'
export default {
    components:{
        BCard,
    },
    data() {
        return {
            fields:[
                { name:"Referans No",key:"ReferenceModelName",thClass:"w-15",tdClass:'text-nowrap',sortable:true},
                { name:"Model Adı",key:"ReferenceModelNameManuel",thClass:"w-15",tdClass:'text-nowrap',sortable:true},
                { name:"Araç Kapasitesi",key:"VehicleCapacity",tdClass:"text-right",sortable:true,},
                { name:"Ortalama Yakıt Tüketimi (LT/KM)",tdClass:"text-right",key:"AvgFuelConsumption",sortable:true,},
                { name:"Ortalama AdBlue Tüketimi (LT/KM)",tdClass:"text-right",key:"AvgAdBlueConsumption",sortable:true,},
                { name:"Sabit Maliyet",tdClass:"text-right",key:"FixedCost",sortable:true,},
                { name:"Ortalama Lastik Maliyeti",tdClass:"text-right",key:"TotalTireUnitCostStr",sortKey:'TotalTireUnitCost',sortable:true},
                { name:"Karlılık Oranı (%)",tdClass:"text-right",key:"ProfitRate",sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        createNew(){
            this.$router.push({name:'vehicle-reference-model-create-or-update',params:{id:0}})
        },
        edit(item){
            this.$router.push({name:'vehicle-reference-model-create-or-update',params:{id:item.Id}})
        },
        provider(data){
            return CalculatePriceApi.ReferenceModel.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.ReferenceModelNameManuel} referans modelini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    CalculatePriceApi.ReferenceModel.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>